import React from 'react';
import { HeartHandshake, ShieldCheck, Globe } from 'lucide-react';
import { Section, Card } from '../hospital/shared/primitives';
import { LinkRow, IntroRow } from '../shared/ListRows';

const ACCENT = '#334155';

const BCMResourcesOverview = () => (
  <div className="space-y-6">
    <Section title="Support">
      <Card>
        <IntroRow icon={HeartHandshake} title="Confidential help, any hour" accent="#047857">
          Counseling and crisis support for everyone in the BCM community.
        </IntroRow>
        <LinkRow title="Employee Assistance Program" subtitle="Free, confidential counseling, 24 hours a day" href="tel:1-800-364-6352" />
        <LinkRow title="988 Suicide and Crisis Lifeline" subtitle="Call or text 988, 24 hours a day" href="tel:988" />
        <LinkRow title="Crisis Text Line" subtitle="Text HOME to 741741" href="sms:741741&body=HOME" />
      </Card>
    </Section>

    <Section title="Reporting">
      <Card>
        <IntroRow icon={ShieldCheck} title="BCM Integrity Hotline" accent="#b45309">
          Compliance, ethics, legal and safety matters. Operated by the BCM Office of Compliance; confidential, with an anonymous option.
        </IntroRow>
        <LinkRow title="Call 1-888-294-8970" href="tel:1-888-294-8970" />
        <LinkRow title="Report online" subtitle="BCM compliance portal" href="https://www.mycompliancereport.com/report?cid=BCM" />
      </Card>
    </Section>

    <Section title="Links">
      <Card>
        <LinkRow icon={Globe} title="Baylor College of Medicine" subtitle="bcm.edu" href="https://www.bcm.edu" accent={ACCENT} />
        <LinkRow icon={Globe} title="Graduate Medical Education office" subtitle="Policies, benefits and programs for residents and fellows" href="https://www.bcm.edu/education/graduate-medical-education" accent={ACCENT} />
      </Card>
    </Section>
  </div>
);

export default BCMResourcesOverview;
